import {defaultState} from './index';
import {fromKeyValuePairs} from '../config';

export default function requestsFactory(http, config) {
  const {authUrl} = config;

  function fetchUserDetails({token}) {
    const url = `${authUrl}/user/${config.database}`;
    const headers = token ? {Authorization: `Bearer ${token}`} : {};
    return http.get(url, {headers}).then(response => response.data);
  }

  function saveUserDetails({country, street, organisation, email, realname, token}) {
    const url = `${authUrl}/user`;
    const headers = token ? {Authorization: `Bearer ${token}`} : {};
    const data = {email, realname, organisation, street, country};
    return http.put(url, data, {headers}).then(response => response.data);
  }

  function changePassword({password}) {
    const url = `${authUrl}/usermgmt/password`;
    const data = {password};
    return http.put(url, data).then(response => response.data);
  }

  function renewToken({username, token, application}) {
    const url = `${authUrl}/tokens`;
    const data = {username, application};
    const headers = token ? {Authorization: `Bearer ${token}`} : {};
    return http.post(url, data, {headers}).then(response => response.data.replace(/^"|"$/g, ''));
  }

  function fetchUserConfig({token}) {
    const url = `${authUrl}/config/user/${config.database}`;
    const headers = token ? {Authorization: `Bearer ${token}`} : {};
    return http.get(url, {headers}).then(response => ({...defaultState.auth.config, ...fromKeyValuePairs(response.data.records)}));
  }

  /**
   * Check whether user has specific permissions
   * @param token access token
   * @param permissions list of permission objects containing username, application, entityType, accessType and entityId
   * @return {*}
   */
  function checkUserAccess({token, permissions}) {
    const url = `${authUrl}/access/list`;
    const headers = token ? {Authorization: `Bearer ${token}`} : {};
    return http.post(url, permissions, {headers}).then(response => response.data);
  }

  function removeSolution({runId}) {
    return http.delete(`/runs/${runId}/solution`);
  }

  function lockScenario({runId}) {
    // TODO: figure out why Tomcat cannot process POST requests with empty payload (Content-Length: 0 and no Content-Type header)
    return http.post(`/runs/${runId}/lock`, {});
  }

  function unlockScenario({runId}) {
    return http.delete(`/runs/${runId}/lock`);
  }

  function removeScenario({runId}) {
    return http.delete(`/runs/${runId}`);
  }

  function setScenarioAsDefault({runId}) {
    return http.put(`/runs/${runId}/default`);
  }

  function unsetScenarioAsDefault({runId}) {
    return http.delete(`/runs/${runId}/default`);
  }

  return {
    fetchUserDetails,
    saveUserDetails,
    changePassword,
    renewToken,
    fetchUserConfig,
    removeSolution,
    lockScenario,
    unlockScenario,
    removeScenario,
    setScenarioAsDefault,
    unsetScenarioAsDefault,
    checkUserAccess,
  };
}
